<template>
  <div>
    <div class="sub-container">
      <div class="contact-header">
        <el-button
          class="btn-add-contact"
          type="primary"
          icon="el-icon-plus"
          @click="openAddDialog"
          >新建患者</el-button
        >
        <div class="search-right">
          <el-input
            class="input-circle"
            v-model="searchText"
            placeholder="姓名或出生日期"
          ></el-input>
          <el-button class="button-search" round @click="search"
            >搜 索</el-button
          >
        </div>
      </div>
      <el-table
        class="contact-table"
        :data="currentContactArray"
        style="width: 100%"
        :border="tableBorder"
        v-show="currentContactArray.length > 0"
      >
        <el-table-column prop="name" align="left" label="姓名" min-width="90">
        </el-table-column>
        <el-table-column prop="sexText" label="性别" align="left" min-width="70">
        </el-table-column>
        <el-table-column label="公历生日" align="left" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.birthday }}
            <span
              v-if="shouldShowTime(scope.row.birthHour, scope.row.birthMinute)"
            >
              {{ formatTimeValue(scope.row.birthHour) }}:{{
                formatTimeValue(scope.row.birthMinute)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="lunarBirthday"
          label="农历生日"
          align="left"
          min-width="170"
        >
        </el-table-column>
        <el-table-column
          prop="phoneNo"
          label="电话号码"
          align="left"
          min-width="140"
        >
        </el-table-column>
        <el-table-column
          prop="liveArea"
          label="常住地址"
          align="left"
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          prop="birthArea"
          label="出生地址"
          align="left"
          min-width="200"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="130">
          <template slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link">
                <el-button class="contact-op-btn" type="text" size="medium"> 操作 </el-button>
                <i
                  class="el-icon-arrow-down el-icon--right contact-dropdown-arrow"
                ></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="contact-op-dropdown">
                <el-dropdown-item
                  @click.native.prevent="startPrescription(scope.$index)"
                  ><el-button class="contact-op-item" type="text" size="medium"><i class="el-icon-edit-outline"></i> 去开方 </el-button>
                </el-dropdown-item>
                <el-dropdown-item @click.native.prevent="editRow(scope.$index)">
                  <el-button class="contact-op-item" type="text" size="medium"><i class="el-icon-edit"></i> 编辑 </el-button>
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native.prevent="deleteRow(scope.$index)"
                >
                  <el-button class="contact-op-item contact-op-delete" type="text" size="medium"><i class="el-icon-delete"></i> 删除 </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-if="totalPage > 10"
        class="pagination"
        background
        layout="prev, pager, next"
        :current-page="currentPageNo"
        @current-change="pageChange"
        :total="totalPage"
      >
      </el-pagination>
      <div class="empty-container" v-if="currentContactArray.length == 0">
        <span>{{ emptyText }}</span>
      </div>
    </div>

    <!-- 使用封装的患者表单弹窗组件 -->
    <patient-form-dialog
      :visible.sync="contactDialogVisible"
      :mode="dialogMode"
      :patient-data="currentEditContact"
      dialog-width="800px"
      :show-tips="true"
      @success="onFormSuccess"
    ></patient-form-dialog>
  </div>
</template>

<script>
import calendar from "js-calendar-converter";
import PatientFormDialog from "@/components/widgets/PatientFormDialog.vue";
export default {
  components: {
    PatientFormDialog: PatientFormDialog,
  },
  data() {
    return {
      tableBorder: false,
      searchText: "",
      currentContactArray: [],
      currentPageNo: 1,
      pageSize: 8,
      totalPage: 1,
      emptyText: "您还没有患者",
      contactDialogVisible: false,
      dialogMode: "add",
      currentEditContact: null,
      pendingEditPatientId: null,
    };
  },
  mounted() {
    if (this.$route.query.editPatientId) {
      this.pendingEditPatientId = this.$route.query.editPatientId;
    }
    this.getContactList();
  },
  methods: {
    shouldShowTime(hour, minute) {
      return !(this.isEmptyValue(hour) && this.isEmptyValue(minute));
    },
    isEmptyValue(value) {
      return value === "" || value === null || value === undefined;
    },
    formatTimeValue(value) {
      if (value === "-1" || value === -1 || value === "--") {
        return "--";
      }
      return value;
    },
    isUserTypeByValue(roles, val) {
      for (var i = 0; i < roles.length; i++) {
        var value = roles[i];
        if (value == val) {
          return true;
        }
      }
      return false;
    },
    getContactList() {
      this.wjtHttp.post(
        this,
        "/api/patient/v1/list",
        {
          name: this.searchText,
          pageNum: this.currentPageNo,
          pageSize: this.pageSize,
        },
        false,
        function (res) {
          var data = res.data;
          if (data.code == 200) {
            var contactList = data.rows;
            this.totalPage = Math.ceil(data.total / 8) * 10;
            if (!this.utils.isEmptyStr(contactList)) {
              for (var i = 0; i < contactList.length; i++) {
                contactList[i].sexText =
                  contactList[i].sex == "1" ? "男" : "女";
                if (!contactList[i].lunarBirthday) {
                  var birthdayArray = contactList[i].birthday.split("-");
                  var lunarDate = calendar.solar2lunar(
                    birthdayArray[0],
                    birthdayArray[1],
                    birthdayArray[2]
                  );
                  contactList[i].lunarBirthday =
                    lunarDate.lYear +
                    "年" +
                    lunarDate.IMonthCn +
                    lunarDate.IDayCn;
                }
              }
            }
            this.currentContactArray = contactList;
            if (this.pendingEditPatientId) {
              var editIndex = -1;
              for (var j = 0; j < contactList.length; j++) {
                if (contactList[j].patientId == this.pendingEditPatientId) {
                  editIndex = j;
                  break;
                }
              }
              if (editIndex >= 0) {
                this.editRow(editIndex);
              }
              this.pendingEditPatientId = null;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "患者查询异常，请联系管理员",
              type: "error",
            });
          }
        }.bind(this),
        function (err) {
          console.log(err);
        }
      );
    },
    search() {
      this.currentPageNo = 1;
      this.getContactList();
    },
    openAddDialog() {
      this.dialogMode = "add";
      this.currentEditContact = null;
      this.contactDialogVisible = true;
    },
    startPrescription(index) {
      var userInfo = this.$store.getters.getUserInfo;
      // userInfo.doctor;
      var roles = "";
      var role = "common";
      var roles = userInfo.roles;
      if (
        this.isUserTypeByValue(roles, "doctor") &&
        userInfo.doctor.status === "0"
      ) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "admin")) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "level1")) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "level2")) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "superadmin")) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "common_doctor")) {
        role = "doctor";
      }
      if (role != "doctor") {
        console.log("roles", role);
        this.$message.error("没有开方权限");
        return;
      } else {
        // sessionStorage.setItem('contactList',JSON.stringify(this.currentContactArray[index]))
        // this.$router.push('/addPrescriptionContact')
        sessionStorage.setItem(
          "contactList",
          JSON.stringify(this.currentContactArray[index])
        );
        this.$router.push({
          path: "/addPrescriptionContact",
          query: {
            serviceIndex:6
          },
        });
      }
    },

    drugRecord(index) {
      var contact = this.currentContactArray[index];
      sessionStorage.setItem("contactInfo", JSON.stringify(contact));
      this.$router.push({
        path: "/medicalRecords",
      });
    },
    editRow(index) {
      this.dialogMode = "edit";
      var contact = JSON.parse(JSON.stringify(this.currentContactArray[index]));
      var birthdayArray;
      if (contact.birthday.indexOf("-") >= 0) {
        birthdayArray = contact.birthday.split("-");
      } else {
        var parts = contact.birthday.split(/\D+/);
        birthdayArray = parts
          .map(function (part) {
            if (part.length < 2) {
              return "0" + part;
            }
            return part;
          })
          .map(Number);
      }
      var lunarObj = calendar.solar2lunar(
        birthdayArray[0],
        birthdayArray[1],
        birthdayArray[2]
      );
      contact.displayBirth =
        "公历" +
        birthdayArray[0] +
        "年" +
        birthdayArray[1] +
        "月" +
        birthdayArray[2] +
        "日" +
        " 农历" +
        lunarObj.lYear +
        "年" +
        lunarObj.IMonthCn +
        lunarObj.IDayCn;
      this.currentEditContact = contact;
      this.contactDialogVisible = true;
    },
    onFormSuccess() {
      this.getContactList();
      this.currentEditContact = null;
    },
    deleteRow(index) {
      this.$confirm("确定删除该患者信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(
          function () {
            var contact = this.currentContactArray[index];
            this.wjtHttp.delete(
              this,
              "/api/patient/v1/" + contact.patientId,
              {},
              false,
              function (res) {
                var data = res.data;
                if (data.code == 200) {
                  this.$message({
                    message: "患者已删除",
                    type: "success",
                  });
                  this.currentEditContact = null;
                  this.getContactList();
                } else {
                  this.$message({
                    message:
                      data.msg && data.msg.length > 0
                        ? data.msg
                        : "删除失败，请联系管理员",
                    type: "error",
                  });
                }
              }.bind(this),
              function (err) {
                console.log(err);
              }
            );
          }.bind(this)
        )
        .catch(function () {});
    },

    pageChange(pageNo) {
      this.currentPageNo = pageNo;
      this.getContactList();
    },
  },
  watch: {
    searchText: function (val) {
      if (this.utils.isEmptyStr(val)) {
        this.currentPageNo = 1;
        this.getContactList();
      }
    },
  },
};
</script>

<style scoped>
.sub-container {
  width: 1160px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 70vh;
  padding-bottom: 100px;
}

.contact-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f9fafb;
  width: 100%;
  border-radius: 14px;
  margin-bottom: 20px;
  gap: 16px;
}

.search-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.btn-add-contact {
  font-size: 16px;
  border-radius: 10px !important;
}

.input-circle {
  width: 260px;
  height: 40px;
}
.input-circle >>> input {
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-color: #e2e8f0;
  height: 40px;
}
.input-circle >>> input:focus {
  border-color: #20863F;
}

.button-search {
  height: 40px;
  width: 100px;
  background-color: #20863F;
  border-color: #20863F;
  color: #fff;
  font-weight: 600;
}
.button-search:hover {
  background-color: #257648;
  border-color: #257648;
  color: #fff;
}

.contact-dropdown-arrow {
  color: #20863F;
}

.contact-op-btn {
  color: #20863F;
  font-weight: 600;
}
.contact-op-btn:hover,
.contact-op-btn:focus {
  color: #257648;
}

.contact-op-dropdown >>> .el-dropdown-menu__item {
  padding: 0 20px;
  line-height: 36px;
}
.contact-op-dropdown >>> .el-dropdown-menu__item:hover {
  background-color: #f3fbf6;
}

.contact-op-item {
  color: #20863F;
  font-weight: 500;
}
.contact-op-item:hover,
.contact-op-item:focus {
  color: #257648;
}
.contact-op-item i {
  margin-right: 4px;
}

.contact-op-delete {
  color: #d35342;
}
.contact-op-delete:hover,
.contact-op-delete:focus {
  color: #b93c2e;
}

.pagination {
  margin-top: 20px;
  margin-bottom: 10px;
  align-self: center;
}


.empty-container {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.empty-container > span {
  font-size: 20px;
  color: #aeaeae;
}

/* 表格绿色主题 */
.contact-table {
  width: 100% !important;
  border: 1px solid #d3e6d8;
  border-radius: 14px;
  overflow: hidden;
}
.contact-table >>> .el-table {
  border: 1px solid #d3e6d8;
  border-radius: 14px;
  overflow: hidden;
}
.contact-table >>> .el-table__header-wrapper,
.contact-table >>> .el-table__body-wrapper {
  border-radius: 14px;
  overflow: hidden;
}
.contact-table >>> .el-table__header thead tr:first-child th:first-child {
  border-top-left-radius: 14px;
}
.contact-table >>> .el-table__header thead tr:first-child th:last-child {
  border-top-right-radius: 14px;
}
.contact-table >>> .el-table--border {
  border-color: #d3e6d8;
}
.contact-table >>> .el-table--border th.el-table__cell,
.contact-table >>> .el-table--border td.el-table__cell {
  border-color: #d3e6d8;
}
.contact-table >>> th.el-table__cell {
  background: #20863F !important;
  color: #fff !important;
  font-weight: 700 !important;
}
.contact-table >>> td.el-table__cell {
  color: #385846;
}
.contact-table >>> .el-table__row:hover > td.el-table__cell {
  background-color: #f3fbf6 !important;
}
</style>

